import React from 'react';

export const ReservationBookTicketPage = () => {
  return <div>ReservationBookTicket</div>;
};
